<template>
  <div :style="{ 'background-color': backgroundColor }" style="height: 100%">

    <b-container>
      <div class="box">
        <b-form v-if="show" @submit="onSubmit">
          <b-row>
            <b-col xl="10" offset-xl="1">
              <h2>{{ $t(title) }}</h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4" offset-lg="1">
              <p class="caption">
                {{ $t("label_surveyInvitation_accessCode_caption") }}
              </p>
            </b-col>
            <b-col lg="6">
              <textarea
                v-model="form.invitations"
                :placeholder="
                  $t(
                    'label_surveyInvitation_provideListAccessControl_field_caption'
                  )
                "
                required
              />
              <p v-if="errorShow" class="error">
                {{
                  $t(
                    "label_surveyInvitation_createInvitations_error_" +
                      error.statusCode
                  )
                }}<br /><strong>{{ error.codes }}</strong>
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <div
                class="invitation-language text-right"
                style="padding-top: 5px"
              >
                {{ $t("label_language_invitationLanguaje_title") }}
              </div>
            </b-col>
            <b-col md="3">
              <div
                class="invitation-language text-right"
                style="padding-right: 20px"
              >
                <b-form-select
                  v-model="selectedLanguage"
                  :options="languageOptions"
                />
              </div>
            </b-col>
            <b-col md="3">
              <b-button variant="primary" type="submit" block>
                {{ $t("label_surveyInvitation_createInvitations_button") }}
              </b-button>
            </b-col>
            <b-col md="3" />
          </b-row>
        </b-form>
      </div>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { axiosCall } from "@/utils/axiosCall";
import {getCurrentDomain, getUrlForCurrentDomain} from "@/utils/urlConfig";

export default {
  name: "SurveySendInvitations",
  components: {},
  props: {
    templateId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "label_surveyInvitation_title",
    },
    managementRoute: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: "#ffffff",
    },
  },
  data: function () {
    return {

      form: {
        invitations: "",
      },
      show: true,
      error: {
        statusCode: "",
        codes: "",
        mails: "",
      },
      errorShow: false,
      selectedLanguage: "es",
      languageOptions: [],
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      const snapshotId = this.getCurrentSnapshot.snapshotId;
      axiosCall({
        url: `Invitations/save/${snapshotId}/${this.selectedLanguage}/${this.templateId}`,
        method: "POST",
        data: { data: this.form.invitations, domain: getCurrentDomain() },
      })
        .then(() => {
          this.$router.push("/" + this.managementRoute + "/survey-management");
        })
        .catch((err) => {
          this.errorShow = true;
          this.error.statusCode = err.response.data.error.statusCode;
          this.error.codes = err.response.data.error.data.codes;
          if (err.response.data.error.data.emails !== "") {
            if(this.error.codes !== "") {
              this.error.codes += ", "
            }
            this.error.codes +=  err.response.data.error.data.emails;
          }
        });
    },
    fillLanguages() {
      this.languageOptions = [
        { value: "en", text: this.$t("headerMenu_language_english_caption") },
        { value: "es", text: this.$t("headerMenu_language_spanish_caption") },
        {
          value: "pt",
          text: this.$t("headerMenu_language_portuguese_caption"),
        },
      ];
      if (this.templateId !== "ViolenceSurvey") {
        this.languageOptions.push({
          value: "tr",
          text: this.$t("headerMenu_language_turkish_caption"),
        });
        this.languageOptions.push({
          value: "bs",
          text: this.$t("headerMenu_language_bosnian_caption"),
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      "isInvitationValid",
      "getCurrentSnapshot",
      "getLang",
      "getUserAccount",
    ]),
  },
  watch: {
    getLang: async function (newValue) {
      this.selectedLanguage = newValue;
      this.fillLanguages();
    },
  },
  mounted() {
    this.selectedLanguage = this.languageOptions.find(
      (option) => option.value === this.getUserAccount.languageIdentifier
    )
      ? this.getUserAccount.languageIdentifier
      : "en";
  },
  created() {
    if (
      this.getCurrentSnapshot.status === "label_configuration_snapshot_accepted"
    ) {
      this.$router.push("/home");
    }
    this.fillLanguages();
  },
};
</script>

<style lang="scss" scoped>

/* components/OpinionSurveySendInvitations*/

@import "../assets/css/variables.scss";

.caption {
  text-align: right;
}
.type-invitation {
  text-align: center;
  input {
    margin-left: 25px;
    margin-right: 5px;
  }
}
textarea {
  width: 100%;
  min-height: 150px;
  background-color: #f1f2f2;
  border-radius: 10px;
  border: 2px solid #bebdbe;

  &::placeholder {
    color: #666;
    text-align: center;
  }
  &:focus,
  &:active {
    outline: none;
  }
}
.btn {
  margin-top: 20px;
}
.error {
  margin: 0px;
  color: $accent-color;
}
.invitation-language {
  margin-top: 20px;
}
</style>
